import React from "react";
import { Link } from "react-router-dom";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

const BreadCrumbs = (props) => {
  const { data } = props;
  return (
    <div className="bread-crumbs">
      {data.map((item, i) => (
        <div className="flex" key={item.name}>
          {i !== 0 && <ChevronRightRoundedIcon />}
          {item.link ? (
            <Link to={item.link} className={`link ${i === data.length - 1 ? "current-link" : ""}`}>
              {item.name}
            </Link>
          ) : (
            <div className={`link ${i === data.length - 1 ? "current-link" : ""}`}>{item.name}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default BreadCrumbs;
